<template>
  <v-card>
    <v-card-title class="headline py-2">
      {{formTitle}} &nbsp;
      <i v-if="data.name"> {{' "'+data.name+'"'}}</i>
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('close-dialog')" class="mx-0"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-divider></v-divider>

    <v-card-text class="overflow-hidden">
      <v-tabs dark color="panel" slider-color="accent">
        <v-tab href="#main">Основные</v-tab>
        <v-tab href="#scope" v-if="editMode">Область видимости</v-tab>
        <v-tab href="#owner" v-if="editMode">Владение</v-tab>
        <v-tab href="#links" v-if="editMode">Ссылки</v-tab>
        <v-tabs-items>
          <v-tab-item value="main">
            <v-card flat>
              <v-card-text class="px-0 pt-2">
                <v-text-field :label="isFolder?'Название':'Файл'" v-model="element.name">
                  <d-file-uploader style="padding: 0" uploadUrl="false" v-if="!isFolder && !editMode" slot="append" @file-added="fileAdded"></d-file-uploader>
                </v-text-field>
                <v-textarea v-if="isFolder" label="Описание" rows="3" auto-grow v-model="element.description"></v-textarea>
                <div v-if="showFolderTree" style="min-height: 100px; max-height: 220px; border: 1px solid #c5c5c5; overflow: auto">
                  <v-treeview :items="folders_tree" item-key="key" class="densed" :load-children="getFolderContent" :active.sync="treeActive">
                      <v-icon slot="prepend" slot-scope="{ item, open, leaf }" size="20">
                        {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                      </v-icon>
                    <label slot="label" class="pointer" slot-scope="{item}" @dblclick="selectFolder(item)">{{item.name}}</label>
                  </v-treeview>
                </div>
                <v-text-field v-else label="Родительская папка" readonly :value="folderName" append-icon="mdi-file-tree"
                              @click="showFolderTree=true" @click:append="showFolderTree=true"></v-text-field>
              </v-card-text>
            </v-card>
          </v-tab-item>
          
          <v-tab-item v-if="editMode" value="scope">
            <v-card flat>
              <v-card-text class="pa-0">
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-data-table :headers="headers" :items="scopeList" hide-actions no-data-text="Данные отсутствуют">
                      <template slot="items" slot-scope="props">
                        <td>{{ props.item.name }}</td>
                        <td class="text-xs-center">{{ (props.item.recursive) ? 'Включая подчиненных' : 'Только выбранным' }}</td>
                        <td class="text-xs-center">{{ (props.item.access==='w') ? 'Доступно редактирование' : 'Только чтение' }}</td>
                        <td class="text-xs-center pa-0 ma-0">
                          <v-btn class="red--text" icon flat @click="deleteObject(props.item.id)"><v-icon>close</v-icon></v-btn>
                        </td>
                      </template>
                    </v-data-table>
                    <span class="dashed pointer pull-right my-2" @click="showTree=!showTree">{{showTree?'Свернуть панель':'Добавить пользователей'}}</span>
                  </v-flex>
                  <v-flex xs6 v-show="showTree">
                    <dantser-tree
                      ref="beingTree"
                      :checkbox="true"
                      :selectMode="2"
                      :source="treedata"
                      :style="{height:'150px', overflow:'scroll', border:'1px solid #c5c5c5'}"
                    ></dantser-tree>
                  </v-flex>
                  <v-flex xs6 class="pl-2" v-show="showTree">
                    <v-checkbox label="Включая подчиненные подразделения" v-model="include_children" hide-details></v-checkbox>
                    <v-checkbox label="Разрешить редактирование" v-model="can_edit" hide-details></v-checkbox>
                    <v-btn color="secondary" class="mt-4 ml-0" @click="addObject">Добавить</v-btn>
                    <p class="red--text" v-show="existError">Такой пользователь уже существует в списке</p>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-tab-item>
          
          <v-tab-item v-if="editMode" value="owner">
            <v-card flat>
              <v-card-text class="px-0 pt-2">
                <v-flex xs12 class="mt-3" v-if="element.owner && element.owner.name">
                  <b>Текущий владелец</b>
                  <p class="ma-0">{{element.owner.name}}</p>
                </v-flex>
                <v-flex xs12 class="mt-3" v-if="transfer && transfer.id">
                  <v-alert :value="true" type="info">
                    <p class="body-2">Находится в состоянии передачи владения пользователю {{transfer.name}}</p>
                    <v-btn color="error" small @click="cancelTransfer">Отменить</v-btn>
                  </v-alert>
                </v-flex>
                <dantser-tree v-else-if="isOwner"
                  label="Выберите пост для передачи владения"
                  :field="true"
                  :checkbox="false"
                  :selectMode="1"
                  :source="treedata"
                  @node-dblclick="setOwner($event)"
                ></dantser-tree>
                <span v-if="not_post" class="red--text"><v-icon>mdi-warning</v-icon> Передать владение можно только посту!</span>
              </v-card-text>
            </v-card>
          </v-tab-item>
          
          <v-tab-item v-if="editMode" value="links">
            <v-card flat>
              <v-card-text class="pa-0">
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-data-table :headers="headersLinks" :items="linksList" hide-actions no-data-text="Ссылки не созданы">
                      <template slot="items" slot-scope="props">
                        <td style="word-break: break-all;">{{getLinkUrl(props.item.token)}}</td>
                        <td class="text-xs-center">{{props.item.type}}</td>
                        <td class="text-xs-center">{{props.item.expiry!=null ? formatDatetime(props.item.expiry).short : 'Бессрочно'}}</td>
                        <td class="text-xs-center">
                          <v-tooltip top>
                            <v-btn slot="activator" :class="props.item.active?'pa-0 green--text':'pa-0 red--text'" icon small flat @click="toggleLink(props.item)">
                              <v-icon>mdi-power</v-icon>
                            </v-btn>
                            <span>{{props.item.active?"Отключить":"Включить"}}</span>
                          </v-tooltip>
                        </td>
                        <td class="text-xs-center pa-0 ma-0">
                          <v-btn class="red--text pa-0" icon small flat @click="deleteLink(props.index)"><v-icon>mdi-delete</v-icon></v-btn>
                        </td>
                      </template>
                    </v-data-table>
                    <span class="dashed pointer pull-right my-2" @click="showLinksBlock=!showLinksBlock">{{showLinksBlock?'Свернуть панель':'Добавить ссылку'}}</span>
                  </v-flex>
                  <v-flex xs12 v-show="showLinksBlock">
                    <v-layout row justify-space-between>
                      <v-flex xs12 md4>
                        <v-select label="Тип" :items="linkTypes" v-model="linkType" hide-details></v-select>
                      </v-flex>
                      <v-flex xs12 md4>
                        <DatetimePicker clearable v-model="linkExpire" label="Срок действия"></DatetimePicker>
                      </v-flex>
                      <v-flex xs12 md3>
                        <v-btn color="secondary" @click="addLink">Добавить</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="pa-3">
      <v-btn color="success" @click="submit" :disabled="status.btnDisabled">Сохранить</v-btn>
      <span :class="status.className" class="ml-2">{{status.text}}</span>
    </v-card-actions>

  </v-card>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import DatetimePicker from '@/components/DatetimePicker'
  import DFileUploader from '@/components/Disk/FileUploader'
  
  export default {
    name : "FolderForm",
  
    props:{
      data:{
        type: Object,
        required: true,
      },
      isFolder: {
        type: Boolean,
        required: true,
      },
      editMode: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    
    components: {
      DFileUploader,
      DatetimePicker
    },
    
    data(){
      return {
        folders_tree: [],
        treeActive: [],
        showFolderTree: false,
        folderName: '',
        element: {},
        scopeList: [],
        headers: [
          { text: 'Пост/Подразделение', align: 'left', sortable: false },
          { text: 'Доступ', align: 'center', sortable: false },
          { text: 'Права', align: 'center', sortable: false },
          { text: 'Действия', align: 'center', sortable: false, width: 40 },
        ],
        headersLinks:[
          { text: 'Ссылка', align: 'left', sortable: false },
          { text: 'Тип', align: 'center', sortable: false },
          { text: 'Срок действия', align: 'center', sortable: false },
          { text: 'Включена', align: 'center', sortable: false },
          { text: '', align: 'center', sortable: false, width: 40 },
        ],
        linksList: [{}],
        can_edit: false,
        include_children: false,
        existError: false,
        showTree: false,
        showLinksBlock: false,
        treedata: [],
        owner: null,
        transfer: null,
        file: null,
        not_post: false,
        linkTypes: [
          {text: 'Внутри системы', value: 'a'},
          {text: 'Доступно всем', value: 'p'}
        ],
        linkType: 'a',
        linkExpire: null,
        status:{
          btnDisabled: false,
          text: '',
          className:'success--text darken-1'
        },
      }
    },
    
    computed:{
      ...mapState(`app/account`, ['postId']),
      ...mapGetters('app/helpers', {
        formatDatetime: 'formatDatetime'
      }),
      ...mapGetters('app/org', ['getPostById','getContainerById']),
      formTitle(){
        return `${this.editMode ? 'Редактировать' : 'Загрузить'} ${this.isFolder ? 'папку диска ' : 'файл '}`
      },
      isOwner(){
        return (this.element.owner && this.element.owner.post_id===this.postId)
      }
    },
  
    created(){
      this.element = JSON.parse(JSON.stringify(this.data))
      if(this.element.dir_name) {
        this.folderName = this.element.dir_name
        let key = this.isFolder ? this.element.parent : this.element.directory
        this.treeActive = ['directory_'+key]
      }
      
      this.$store.dispatch('disk/systemDisk').then(response => {
        if(response.directories){
          this.folders_tree = response.directories
          if(this.isFolder){
            this.folders_tree = response.directories.filter( el => el.id!==data.id)
          }
        } else {
          this.folders_tree = this.filterFolders(response)
        }
        this.folders_tree = [{id: null, name: 'Мои файлы', children: this.folders_tree}]
      })
      
      if(this.editMode){
        this.getPermissions()
        //this.getTransfer()
        this.getLinks()
        this.$store.dispatch('app/org/tree', 'other').then(usersTree => {
          this.treedata = usersTree
        })
  
        if(this.element.owner){
          let post = this.getPostById(this.element.owner.post_id)
          if(post.loaded){
            this.element.owner.name = post.name+' '+post.fullname
          } else {
            this.$store.dispatch('app/org/entitiesInfo', { posts: [this.element.owner.post_id], containers: [] }).then( response => {
              if(response.posts_data && response.posts_data[0]){
                this.$store.commit('app/org/addPosts', response.posts_data)
                this.element.owner.name = response.posts_data[0].name+' '+response.posts_data[0].fullname
              }
            })
          }
        }
      }
    },
    
    methods: {
      submit(){
        this.status = { btnDisabled : true, text : 'Сохранение', className : 'grey--text lighten-1' }
        let data = {}
        if(this.isFolder){
          let { id, name, description, parent } = this.element
          let change_owner = false
          data = { id, name, description, parent }
          if(this.owner){
            data.owner_post_id = this.owner.post_id
            data.owner_user_id = this.owner.user_id
            change_owner = true
          }
          this.$store.dispatch('disk/updateFolder', data).then( response => {
            this.status = { btnDisabled : false, text : 'Сохранено', className : 'success--text darken-1' }
            this.$emit('save', {type: 'saveFolder', data: response, change_owner})
          }).catch( error => {
            this.$dmsErrorNoty('Ошибка сохранения папки')
          })
        } else {
          if(this.file){
            let formData = new FormData
            formData.append("file", this.file);
            formData.append('name', this.element.name)
            formData.append('directory', this.element.directory)
            this.$store.dispatch('disk/uploadFile', formData).then( response => {
              this.status = { btnDisabled : false, text : 'Сохранено', className : 'success--text darken-1' }
              this.$emit('save', {type: 'addFile', data: response})
            }).catch( error => {
              this.status = { btnDisabled : false, text : 'Ошибка', className : 'error--text darken-1' }
              this.$dmsErrorNoty('Ошибка сохранения папки')
            })
          } else if(this.editMode) {
            let { id, name, directory } = this.element
            data = { id, name, directory }
            let change_owner = false
            if(this.owner){
              data.owner_post_id = this.owner.post_id
              data.owner_user_id = this.owner.user_id
              change_owner = true
            }
            this.$store.dispatch('disk/updateFile', data).then( response => {
              this.status = { btnDisabled : false, text : 'Сохранено', className : 'success--text darken-1' }
              this.$emit('save', {type: 'saveFile', data: response, change_owner})
            }).catch( error => {
              this.status = { btnDisabled : false, text : 'Ошибка', className : 'error--text darken-1' }
              this.$dmsErrorNoty('Ошибка сохранения папки')
            })
          } else {
            this.$dmsErrorNoty('Выберите файл для загрузки')
          }
        }
      },
  
      filterFolders(tree){
        let data = JSON.parse(JSON.stringify(tree))
        let result = []
        if(this.isFolder){
          result = data.filter( el => (el.key.indexOf('directory')>=0 && this.data.id!==el.id) )
        } else {
          result = data.filter( el => el.key.indexOf('directory')>=0)
        }
        result.map(folder => {
          folder.children = this.filterFolders(folder.children)
        })
        return result
      },
  
      async getFolderContent(item) {
        await this.$store.dispatch('disk/getDirectoryContent', item.id).then( response => {
          item.children = response.directories
        })
      },
      
      selectFolder(item){
        this.showFolderTree=false
        this.folderName = item.name
        if(this.isFolder){
          this.element.parent = item.id
        } else {
          this.element.directory = item.id
        }
      },
  
      addObject(){
        let nodes = this.$refs['beingTree'].getNodesByProp('selected', true)
        if(nodes.length>0){
          let data = []
          nodes.map( node => {
            this.$refs['beingTree'].setSelected(node.id, false)
            if( this.scopeList.findIndex( el => (el.post_id === node.id || el.department_id === node.id )) < 0 ){
              let obj = {
                post_id: (node.element_type==='post') ? node.id : null,
                department_id: (node.element_type==='container') ? node.id : null,
                recursive: (this.include_children && node.element_type !== 'post'),
                name: node.name,
                access: (this.can_edit) ? 'w' : 'r'
              }
              data.push(obj)
            }
          })
          this.include_children = false
          this.can_edit = false
          if(data.length>0){
            let type = this.isFolder ? 'directory' : 'file'
            let id = this.element.id
            this.$store.dispatch('disk/addPermission', {id, type, data}).then(response => {
              response.map(item=>{
                let obj = data.find(el => item.post_id===el.post_id && item.department_id===el.department_id)
                if(obj){
                  item.name = obj.name
                }
              })
              this.scopeList = this.scopeList.concat(response)
            })
          }
        }
      },
  
      deleteObject(id){
        const index = this.scopeList.findIndex( el => el.id === id )
        if(index >= 0){
          this.$store.dispatch('disk/deletePermission', id).then( response => {
            this.scopeList.splice(index, 1)
          }).catch( error => {
            this.$dmsErrorNoty('Возникла ошибка при удалени элемента')
          })
        }
      },
  
      fileAdded(file){
        this.file = file.fileData
        this.element.name = file.fileData.name
      },
  
      setOwner(data){
        this.not_post = (data.element_type !== 'post')
        if(data.element_type === 'post'){
          this.owner = { post_id: data.id, user_id: data.account_id }
        }
      },
      
      getPermissions(){
        let type = this.isFolder ? 'directory' : 'file'
        this.$store.dispatch('disk/getPermissions', {id: this.element.id, type}).then( response => {
          this.scopeList = response
          let posts = [], containers = []
          this.scopeList.map( item => {
            if (item.department_id){
              let container = this.getContainerById(item.department_id)
              if(container.loaded){
                item.name = container.name
              } else if(!containers.includes(item.department_id)){
                containers.push(item.department_id)
              }
            } else if(item.post_id){
              let post = this.getPostById(item.post_id)
              if(post.loaded){
                item.name = post.name
              } else if(!posts.includes(item.post_id)){
                posts.push(item.post_id)
              }
            }
          })
          this.$store.dispatch('app/org/entitiesInfo', { posts, containers }).then( response => {
            this.$store.commit('app/org/addPosts', response.posts_data)
            this.$store.commit('app/org/addContainers', response.containers_data)
            
            this.scopeList.map( item => {
              if (item.department_id){
                let container = this.getContainerById(item.department_id)
                if(container.loaded){
                  item.name = container.name
                } else {
                  item.name = 'Неизвестный объект'
                }
              } else if(item.post_id){
                let post = this.getPostById(item.post_id)
                if(post.loaded){
                  item.name = post.name
                } else {
                  item.name = 'Неизвестный объект'
                }
              }
            })
            
            response.posts_data.map( post => {
              const index = this.scopeList.findIndex( el => el.post_id===post.id)
              if (index>=0) this.$set(this.scopeList[index], 'name', post.name)
            })
            
            
            response.containers_data.map( container => {
              const index = this.scopeList.findIndex( el => el.department_id===container.id)
              if (index>=0) this.$set(this.scopeList[index], 'name', container.name)
            })
          })
        })
      },
  
      /*getTransfer(){
        let type = this.isFolder ? 'directory' : 'file'
        this.$store.dispatch('disk/getTransfer', {id: this.element.id, type}).then( response => {
          if(response.id && response.receiver){
            this.transfer = response
            this.$store.dispatch('app/org/entitiesInfo', { posts: [response.receiver.post_id], containers: [] }).then( response => {
              if(response.posts_data && response.posts_data[0]){
                this.transfer.name = response.posts_data[0].name+''+response.posts_data[0].fullname
              }
            })
          }
        })
      },*/
  
      cancelTransfer(){
        this.$store.dispatch('disk/deleteTransfer', this.transfer.id).then( response => {
          this.transfer = null
        })
      },
      
      getLinks(){
        let id = this.element.id
        let type = this.isFolder ? 'directory' : 'file'
        this.$store.dispatch('disk/getLinks', {type, id}).then( response => {
          this.linksList = response
        })
      },
  
      addLink(){
        let data = {
          type: this.linkType,
          expiry: this.linkExpire
        }
        let id = this.element.id
        let type = this.isFolder ? 'directory' : 'file'
        this.$store.dispatch('disk/createLink', {type, id, data}).then( response => {
          this.linksList.push(response)
          this.linkType = 'a'
          this.linkExpire = null
        }).catch( error => {
          this.$dmsErrorNoty('Возникла ошибка при попытке добавить ссылку.')
        })
      },
  
      toggleLink(link){
        link.active = !link.active
        let data = {
          active: link.active
        }
        this.$store.dispatch('disk/updateLink', {id: link.id, data}).catch( error => {
          this.$dmsErrorNoty('Возникла ошибка при попытке изменить состояние ссылки. Состояние было сброшено на предыдущее.')
          link.active = !link.active
        })
      },
  
      deleteLink(index){
        this.$store.dispatch('disk/deleteLink', this.linksList[index].id).then( response => {
          this.linksList.splice(index, 1)
        }).catch( error => {
          this.$dmsErrorNoty('Возникла ошибка при попытке удалить ссылку.')
        })
      },
  
      getLinkUrl(token){
        return location.origin+'/disc/'+token
      }
    }
  }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/apps/disk/components/Folders/Forms/FolderForm.vue